import { useState } from 'react';

import Tabs from '@mui/material/Tabs';

import Tab from '@mui/material/Tab';

import _ from 'lodash';

import Router from 'next/router';

import PropTypes from 'prop-types';

import { Button, FadeInAnimation } from '../../shared';

import useResponsive from '../../../../utils/responsive';

const BuildingDescription = (props) => {
    const { isMobile } = useResponsive();
    const { selectedBuilding, cities } = props;
    const id = _.get(selectedBuilding, 'id');
    const cityId = _.get(selectedBuilding, 'address.cityId');
    const city = _.find(cities, { id: cityId });
    const details = _.get(selectedBuilding, 'details');
    const [activeValue, setActiveValue] = useState(0);

    const onBookYourSpaceClick = () => {
        Router.push(`/bookings?city=${_.get(city, 'name')}&building=${id}`).then(() =>
            window.scrollTo(0, 0),
        );
    };

    const LinkTab = (linkTabProps) => {
        const { activeVal, ...rest } = linkTabProps;
        return (
            <Tab
                className='building-description-tab'
                component="a"
                onMouseEnter={() => setActiveValue(activeVal)}
                onMouseLeave={() => setActiveValue(0)}
                {...rest}
            />
        );
    };

    const renderListNav = () => {
        if (isMobile) {
            return null;
        }
        return (
            <FadeInAnimation>
                <Tabs value={activeValue} id="building-description-nav" className='building-description-navigation-tabs'>
                    <LinkTab
                        label="Building Amenities"
                        id="building-amenities-list-button"
                        href="#building-amenities-section"
                        activeVal={0}
                    />
                    <LinkTab
                        label="Location"
                        id="location-list-button"
                        href="#location-section"
                        activeVal={1}
                    />
                    <LinkTab
                        label="Reviews"
                        id="review-list-button"
                        href="#review-section"
                        activeVal={2}
                    />
                    <LinkTab
                        label="Other Spaces"
                        id="spaces-list-button"
                        href="#other-spaces-section"
                        activeVal={3}
                    />
                </Tabs>
            </FadeInAnimation>
        );
    };

    const renderDetails = () => {
        if (!details) {
            return null;
        }
        return (
            <FadeInAnimation>
                <div>
                    <h3 className='building-description-header3'>The Details</h3>
                    <p className='building-description-details'>{details}</p>
                    {renderBookYourSpaceButton()}
                    <hr className='building-description-hr' />
                </div>
            </FadeInAnimation>
        );
    };

    const renderBookYourSpaceButton = () => {
        return (
            <Button
                className='building-description-button'
                type="primary"
                id="main-book-your-space-button"
                onClick={onBookYourSpaceClick}
            >
                Book Your Space
            </Button>
        );
    };

    return (
        <>
            {renderListNav()}
            {renderDetails()}
        </>
    );
};

export default BuildingDescription;

BuildingDescription.propTypes = {
    selectedBuilding: PropTypes.object,
    cities: PropTypes.object,
};

